export const FETCH_CNC_MANUAL_WEBORDER_STATUS =
  "FETCH_CNC_MANUAL_WEBORDER_STATUS";
export const FETCH_CNC_MANUAL_WEBORDER_STATUS_SUCCESS =
  "FETCH_CNC_MANUAL_WEBORDER_STATUS_SUCCESS";
export const FETCH_CNC_MANUAL_WEBORDER_STATUS_FAILURE =
  "FETCH_CNC_MANUAL_WEBORDER_STATUS_FAILURE";
export const RESET_CNC_MANUAL_WEBORDER_STATUS =
  "RESET_CNC_MANUAL_WEBORDER_STATUS";
export const MODIFY_CNC_MANUAL_WEBORDER_STATUS =
  "MODIFY_CNC_MANUAL_WEBORDER_STATUS";
export const MODIFY_CNC_MANUAL_WEBORDER_STATUS_SUCCESS =
  "MODIFY_CNC_MANUAL_WEBORDER_STATUS_SUCCESS";
export const MODIFY_CNC_MANUAL_WEBORDER_STATUS_FAILURE =
  "MODIFY_CNC_MANUAL_WEBORDER_STATUS_FAILURE";
export const SET_CNC_SCANNED_DATA = "SET_CNC_SCANNED_DATA";
export const FETCH_CNC_SCANNED_WEBORDER_STATUS =
  "FETCH_CNC_SCANNED_WEBORDER_STATUS";
export const FETCH_CNC_SCANNED_WEBORDER_STATUS_SUCCESS =
  "FETCH_CNC_SCANNED_WEBORDER_STATUS_SUCCESS";
export const FETCH_CNC_SCANNED_WEBORDER_STATUS_FAILURE =
  "FETCH_CNC_SCANNED_WEBORDER_STATUS_FAILURE";
export const RESET_CNC_SCANNED_WEBORDER_STATUS =
  "RESET_CNC_SCANNED_WEBORDER_STATUS";
export const MODIFY_CNC_SCANNED_WEBORDER_STATUS =
  "MODIFY_CNC_SCANNED_WEBORDER_STATUS";
export const MODIFY_CNC_SCANNED_WEBORDER_STATUS_SUCCESS =
  "MODIFY_CNC_SCANNED_WEBORDER_STATUS_SUCCESS";
export const MODIFY_CNC_SCANNED_WEBORDER_STATUS_FAILURE =
  "MODIFY_CNC_SCANNED_WEBORDER_STATUS_FAILURE";
